import React, { useEffect, useState } from "react";
import { IonLabel, IonButton, IonCard, IonModal, IonContent, IonList } from "@ionic/react";
import { Capacitor } from "@capacitor/core";
import database from "../Database";
import { SitePhoto } from "../models/SitePhoto";
import SitePhotoItem from "./SitePhotoItem";
import { User } from "../models/User";
import { SitePhotoType } from "../models/SitePhotoType";

// import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";

interface Props {
    sitePhotos?: SitePhoto[];
    onSitePhotoDeleted: (sitePhotoId: string) => void;
    isReadOnly: boolean;
    editablePhotoTypes: SitePhotoType[];
    permitId: string;
    permitRegisterUsers?: User[];
}

export interface SitePhotoInfo extends SitePhoto {
    filePath: String;
}

const SitePhotosList: React.FC<Props> = ({
    sitePhotos,
    permitId,
    onSitePhotoDeleted,
    isReadOnly,
    editablePhotoTypes,
    permitRegisterUsers,
}) => {
    const [showModal, setShowModal] = useState(false);
    const [selectedPhotoPath, setSelectedPhotoPath] = useState("");
    const [sitePhotoInfos, setSitePhotoInfos] = useState([] as Array<SitePhotoInfo>);

    useEffect(() => {
        const photos: Array<SitePhotoInfo> = [];
        const filePromises: Array<Promise<void>> = [];
        sitePhotos?.forEach((photo) => {
            filePromises.push(
                database.loadPermitFile(permitId, photo.fileKey).then(
                    (result: any) => {
                        if (result) {
                            photos.push({
                                ...photo,
                                filePath: Capacitor.convertFileSrc(result),
                            });
                        }
                    },
                    (err) => {
                        //setFilePath('');
                    }
                )
            );
        });
        Promise.all(filePromises).then(() => {
            setSitePhotoInfos(photos);
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [sitePhotos]);

    const handlePhotoClick = (filePath: string) => {
        setSelectedPhotoPath(filePath);
        setShowModal(true);
    };

    const renderPhotos = (sitePhotoInfo: SitePhotoInfo) => {
        return (
            <SitePhotoItem
                createdBy={permitRegisterUsers?.find((u) => u.id === sitePhotoInfo.createdById)}
                onClick={handlePhotoClick}
                sitePhoto={sitePhotoInfo}
                isReadOnly={isReadOnly || !editablePhotoTypes.some((type) => type.key === sitePhotoInfo.type.key)}
                onSitePhotoDeleted={onSitePhotoDeleted}
            />
        );
    };

    return (
        <>
            <IonModal isOpen={showModal}>
                <IonContent>
                    <IonCard>
                        <img alt="SitePhoto" src={selectedPhotoPath} />
                    </IonCard>
                </IonContent>
                <IonButton onClick={() => setShowModal(false)}>Close</IonButton>
            </IonModal>

            {sitePhotoInfos.length > 0 ? (
                <IonList inset style={{ margin: "0px" }}>
                    {sitePhotoInfos.map(renderPhotos)}
                </IonList>
            ) : (
                <p>
                    <IonLabel style={{ marginLeft: "16px" }} class="ion-text-wrap">
                        There are no photos to display
                    </IonLabel>
                </p>
            )}
        </>
    );
};

export default SitePhotosList;
